import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity, File, Link } from "../../../api/classes";
import { Avatar, Typography, List, Input, IconButton } from "@material-ui/core";
import CaseActivity from "../components/activity";
import SendIcon from "@material-ui/icons/Send";
import { DubitoSvc } from "src/api";
import { hasPermissionOf } from "src/auth/auth";
import { Permissions } from "src/api/constants";
import EmptyState from "src/components/emptyState";

interface Props {
  case_id: number;
  user: User;
  activities: Activity[];
  onUpdate: () => void;
}
class CaseActivities extends React.Component<Props> {
  state = {
    files: [] as File[],
    links: [] as Link[],
    text: ""
  };
  componentWillMount() {}
  sendActivity = () => {
    DubitoSvc.addActivity({
      case_id: this.props.case_id,
      text: this.state.text
    }).then(res => {
      this.setState({ text: "" });
      this.props.onUpdate();
    });
  };
  onDelete = (activity: Activity) => {
    DubitoSvc.deleteActivity({
      case_id: this.props.case_id,
      activity_id: activity.id
    }).then(res => {
      this.props.onUpdate();
    });
  };
  render() {
    const { user, activities } = this.props;
    const canEdit = hasPermissionOf(Permissions.EDIT_CASES);

    return (
      <div style={{ marginLeft: 12 }}>
        {canEdit && (
          <div
            style={{
              display: "flex",
              padding: 12,
              backgroundColor: "#F4F1EE",
              borderRadius: 8
            }}
          >
            <Input
              style={{
                backgroundColor: "white",
                borderRadius: 24,
                marginRight: 12,
                marginTop: 4,
                marginBottom: 4,
                paddingLeft: 12,
                paddingTop: 12,
                flex: 1
              }}
              multiline
              value={this.state.text}
              onChange={e => this.setState({ text: e.target.value })}
              inputProps={{
                flex: 1
                // verticalTextAlign: "center"
              }}
              disableUnderline
              placeholder="Type Your Message"
            />
            <IconButton onClick={this.sendActivity}>
              <SendIcon />
            </IconButton>
          </div>
        )}
        <List>
          {this.props.activities.length === 0 ? (
            <EmptyState message="There is no activity yet" />
          ) : (
            this.props.activities.map(a => {
              return (
                <CaseActivity
                  key={a.id}
                  activity={a}
                  onDelete={canEdit ? this.onDelete : undefined}
                />
              );
            })
          )}
        </List>
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseActivities);



// WEBPACK FOOTER //
// ./src/pages/cases/detail/activity.tsx